/**
 * 服务类型工具函数
 */

/**
 * 获取服务类型颜色
 */
export function getServiceTypeColor(type: string): string {
  const colors: Record<string, string> = {
    video_translation: 'blue',
    document_translation: 'green',
    message_translation: 'orange',
    hot_word_extraction: 'purple',
    hot_word_translation: 'purple',
    speech_to_text: 'cyan',
    speech_translation: 'geekblue',
    ai_chat: 'magenta',
    lesson_generation: 'gold',
    lesson_translation: 'lime',
  }
  return colors[type] || 'default'
}

/**
 * 获取服务类型名称
 */
export function getServiceTypeName(type: string, t?: (key: string) => string): string {
  const names: Record<string, string> = {
    video_translation: '视频翻译',
    document_translation: '文档翻译',
    message_translation: '消息翻译',
    hot_word_extraction: '热词提取',
    hot_word_translation: '热词翻译',
    speech_to_text: '语音转文字',
    speech_translation: '会议翻译',
    ai_chat: 'AI对话',
    lesson_generation: '教案生成',
    lesson_translation: '教案翻译',
  }
  
  if (t) {
    const i18nKeys: Record<string, string> = {
      video_translation: 'usage.videoTranslation',
      document_translation: 'usage.documentTranslation',
      message_translation: 'usage.messageTranslation',
      hot_word_extraction: 'usage.hotWordExtraction',
      hot_word_translation: 'usage.hotWordTranslation',
      speech_to_text: 'usage.speechToText',
      speech_translation: 'usage.speechTranslation',
      ai_chat: 'usage.aiChat',
      lesson_generation: 'usage.lessonGeneration',
      lesson_translation: 'usage.lessonTranslation',
    }
    return t(i18nKeys[type] || type) || names[type] || type
  }
  
  return names[type] || type
}

